import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {ProfileMenuItem} from "./layouts/profile-menu/profile-menu-item.enum";

@Injectable({
  providedIn: 'root'
})
export class ProfileRouterUtil {

  private static readonly PROFILE_SETTINGS_URL = 'profile-settings/';

  private static readonly menuItems: ProfileMenuItem[] = [
    ProfileMenuItem.PERSONAL_INFORMATION,
    ProfileMenuItem.PAYMENT_METHOD,
    ProfileMenuItem.SUBSCRIPTION_HISTORY,
    ProfileMenuItem.MY_PLAN
  ];

  protected currentRoute!: string;

  constructor(
    private readonly router: Router
  ) {
    if (this.noAnyMenuItemActive()) {
      this.navigateToPage(ProfileMenuItem.PERSONAL_INFORMATION);
    }
  }

  get getMenuItems() {
    return ProfileRouterUtil.menuItems;
  }

  get commonUrl() {
    return ProfileRouterUtil.PROFILE_SETTINGS_URL;
  }

  public navigateToPage(item: ProfileMenuItem): void {
    let url = `${this.commonUrl}${this.getRouteByProfileMenuItem(item)}`
    this.router.navigate([
      url
    ]).then(() => this.updateCurrentRoute());
  }

  public isRouteActive(item: ProfileMenuItem) {
    this.updateCurrentRoute();
    return this.currentRoute.includes(
      this.getRouteByProfileMenuItem(item)
    )
  }

  private getRouteByProfileMenuItem(item: ProfileMenuItem) {
    return item.replaceAll(' ', '-').toLowerCase();
  }

  private updateCurrentRoute() {
    this.currentRoute = this.router.url;
  }

  private noAnyMenuItemActive() {
    this.updateCurrentRoute();
    let noAnyActiveMenuItem: boolean = true;
    this.getMenuItems.forEach((item) => {
      if(this.isRouteActive(item)) {
        noAnyActiveMenuItem = false;
      }
    })
    return noAnyActiveMenuItem;
  }
}
